// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue/dist/vue.esm.js'
//import Vue from 'vue'
import App from './App'
// import 'babel-polyfill'
import Router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/js/ty-msg.js'
import store from './store/index'
import './assets/js/tool.js'
import './assets/js/common.js'
import './assets/css/common.css'
import './assets/js/monitor.js' //监听半小时不操作页面
import * as filters from '@/filters' // 全局filter
import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)
    // import pub from "./assets/js/default"
    // Vue.prototype.pub = pub;

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
})

//引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.use(Element)

// import axios from './api/http'
// import axios from 'axios'
// Vue.prototype.$http = axios
// import api from './api/test.js'
// 将API方法绑定到全局
// Vue.prototype.$api = axios
import axios from './api/api';
Vue.prototype.$api = axios;

// 全局导航钩子
Router.beforeEach((to, from, next) => {
    // debugger
    const route = ['index', 'list'];
    let isLogin = localStorage.getItem("token"); // 是否登录
    // 未登录状态；当路由到route指定页时，跳转至login
    if (route.indexOf(to.name) >= 0) {
        if (isLogin == null) {
            Router.push({ path: '/login', });
        }
    }
    // 已登录状态；当路由到login时，跳转至home 
    localStorage.setItem('routerName', to.name)
    if (to.name == 'login') {
        if (isLogin != null) {
            Router.push({ path: '/homePage', });
        }
    }
    next();
});
// router.beforeEach((to, from, next) => {
//   if(to.path=="/login"){
//    next()
//   }else{
//    if(!localStorage.getItem("token")){
//       next({path: '/login'})
//    }else{
//       next();
//    }
//   }
// })



/* eslint-disable no-new */
 new Vue({
     el: '#app',
     router:Router,     
     store,          
     components: { App },
     template: '<App/>'   
 })

//new Vue({
//    router,
//    store,
//    render:h=>h(App)

//}).$mount("#app")


// WEBPACK FOOTER //
// ./src/main.js